import { useState, useEffect } from 'react';
import authToken, { onTokenChange } from 'src/utils/auth';

const useAuth = () => {
  const [token, setToken] = useState(() => authToken());

  useEffect(() => {
    const authenticated = authToken();
    if((!authenticated && token) || (authenticated && token && authenticated.accessToken !== token.accessToken)){
      setToken(authenticated);
    }  
    const handleTokenChange = ({ detail: { token: currentToken } }) => {
      setToken(currentToken);
    };

    return onTokenChange(handleTokenChange);
  });

  return [!!token, token];
};

export default useAuth;
